import axios from 'axios';
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _getCountry = '/Country';
const getCountry = axios.create({
  baseURL: checkEnvironment(_basic, _getCountry)
})



/**
 * 所有的國家
 * @param {number} langId 語系代號
 */
export const getAllCountry = async (langId) => {
  return await getCountry.get(
    '/GetCountryAll',
    { params: { languageID: langId } }
  )
}

/**
 * 指定的國家
 * @param {{languageID:number, countryID: number}} requireData
 */

export const getSpecificCountry = async (requireData) => {
  return await getCountry.get(
    '/GetCountryOnly',
    {
      params: {
        languageID: requireData.languageID,
        countryID: requireData.countryID
      }
    }
  )
}
